module.exports = __webpack_public_path__ + "static/img/moments-default.275af4fa.png";